<template>
  <v-skeleton-loader
    :loading="$store.getters['directories/loading']"
    type="list-item-two-line"
  >
    <v-select
      v-model="selected"
      :dense="dense"
      :menu-props="{maxHeight: 500}"
      :disabled="disabled"
      :items="items"
      item-text="name"
      item-value="id"
      label="Статус заявки"
      :item-color="$store.getters['settings/dark'] ? 'white' : 'black'"
      :error-messages="errorMessages"
      @input="onSelectedChanged"
      @blur="onBlur"
    />
  </v-skeleton-loader>
</template>

<script>
export default {
  props: ['value', 'disabled', 'canAny', 'errorMessages', 'dense'],

  data: () => ({
    selected: null
  }),

  computed: {
    items: function () {
      return this.canAny
        ? [...[{ id: 0, name: '[ Любой ]' }], ...this.$store.getters['directories/requestStatuses']]
        : this.$store.getters['directories/requestStatuses']
    }
  },

  watch: {
    value: function (val) {
      this.selected = val
    }
  },

  created () {
    this.selected = this.value
  },

  methods: {
    onSelectedChanged (val) {
      this.$emit('input', val)
    },
    onBlur (val) {
      this.$emit('blur', val)
    }
  }
}
</script>
